// Microsoft's Secure Score texts arrive as HTML with entities (&nbsp;, &ldquo; ...). Tags go first and entities after, so a
// decoded "<" is only ever shown as a character. Mirrors plainText() in azure-function/src/lib/secureScoreControls.js; the copy
// here also cleans texts that were cached before that fix.
const NAMED = { nbsp: ' ', amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", ldquo: '"', rdquo: '"', lsquo: "'", rsquo: "'", ndash: '-', mdash: '-', hellip: '...', bull: '-' };

export function plainText(html) {
  if (!html) return '';
  return String(html)
    .replace(/<\/?(?:b|i|u|em|strong|span|a|code)(?:\s[^>]*)?>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&(#x[0-9a-f]+|#[0-9]+|[a-z]+);/gi, (m, e) => {
      if (e[0] === '#') {
        const code = e[1] === 'x' || e[1] === 'X' ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
        return Number.isFinite(code) && code > 0 && code < 0x110000 ? String.fromCodePoint(code) : ' ';
      }
      const named = NAMED[e.toLowerCase()];
      return named === undefined ? m : named;
    })
    .replace(/\s+/g, ' ')
    .replace(/\s+([.,;:!?])/g, '$1')
    .trim();
}
